








































































































import Vue from "vue";
import router from "@/router/router";
import { Route } from "vue-router";
import { store } from "@/store/store";
import { ActionTypes } from "@/store/modules/Auth/actions-types";

// components
import Alert from "@/components/Popup/Alert/Alert.vue";

declare interface ConnectionBaseData {
  email: string;
  password: string;
  showPassword: boolean;
  error: boolean;
  errorText: string;
  errorTiming: number;
  disabledConnectionButton: boolean;
  loading: boolean;
  rules: Array<unknown>;
}

export default Vue.extend({
  name: "Connection",
  components: { Alert },
  data: (): ConnectionBaseData => {
    return {
      email: "",
      password: "",
      showPassword: false,
      error: false,
      errorTiming: 0,
      disabledConnectionButton: false,
      errorText: "",
      loading: false,
      rules: [
        (value: string): boolean | string => value.length > 0 || `Le champ nom d'utilisateur est obligatoire`,
        (value: string): boolean | string => value.length > 0 || `Le champ mot de passe est obligatoire`
      ]
    };
  },
  methods: {
    async login(): Promise<Route | undefined> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.loading = true;
        const response = await store.dispatch(ActionTypes.AUTH_LOGIN, {
          mail: String(this.email),
          password: String(this.password)
        });
        if (response.status === 200) return router.push({ path: "/dashboard" });
        else {
          this.errorText = response.message;
          this.error = true;
        }
        this.loading = false;
      }
    },
    checkIfButtonShouldBeDisabled(): void {
      if (this.email.length == 0 && this.password.length == 0) this.disabledConnectionButton = true;
      else this.disabledConnectionButton = false;
    },
    stopDisplayError(): void {
      this.error = false;
    }
  },
  watch: {
    email(): void {
      this.checkIfButtonShouldBeDisabled();
    },
    password(): void {
      this.checkIfButtonShouldBeDisabled();
    },
    error(): void {
      if (this.error) {
        this.errorTiming = window.setTimeout(() => {
          this.error = false;
        }, 3000);
      } else window.clearTimeout(this.errorTiming);
    }
  }
});
